import type { MessageKey } from './pt.js';

/** Ajustes de português europeu sobre o texto neutro. */
export const ptPT: Partial<Record<MessageKey, string>> = {
  'create.capacityHint': 'As regras são definidas com quem estiver presente no início.',
  'lobby.share': 'Partilhar',
  'lobby.copy': 'Copiar ligação',
  'lobby.copied': 'Ligação copiada',
  'lobby.link': 'Ligação da sala',
  'game.dragHint': 'Arrasta a carta destacada até ao centro.',
  'howto.install':
    'Abre o menu do navegador e escolhe "Adicionar ao ecrã principal" para jogar em ecrã inteiro.',
  'errors.CONNECTION': 'Sem ligação ao servidor.',
};
